export const minSelectableYear = 2017;

export const maxYearRange = 3;